export default __webpack_public_path__ + "static/media/questionBlack.aab7711f.svg";